import { Box } from "@mui/material";
import CollapseHeader from "../../../core/common/collapse-header";
import PowerBiDashboard from "../leadsDashboard/components/PowerBiDashborad";

const AIDashboard = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const title = baseUrl?.split("//")[1]?.split(".")[0].toUpperCase();
  const src = process.env.REACT_APP_POWER_BI_REPORT_URL;

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="page-header">
              <div className="row align-items-center ">
                <div className="col-md-4">
                  <h3 className="page-title">AI Dashboard</h3>
                </div>

                <div className="col-md-8 float-end ms-auto mb-2">
                  <div className="d-flex gap-2 title-head">
                    <PowerBiDashboard btnName="Open in Full Window" />

                    <div className="daterange-picker d-flex align-items-center justify-content-center">
                      <div className="head-icons mb-0">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>

                <Box>
                  <iframe
                    title={`${title} E-Dashboard | Power BI`}
                    className="w-100 border-0"
                    style={{ height: "88vh" }}
                    src={src}
                    frameborder="0"
                    allowFullScreen="true"
                  ></iframe>
                </Box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIDashboard;
